/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  let subMenuTriggers = null;
  let subMenus = null;
  let activeSubMenuIndex = -1;
  let searchTrigger = null;
  let searchContainer = null;
  let closeSubMenuTimer = null;

  // function initScrollToAnchor() {
  //   const links = document.querySelectorAll('a[href^="#"]');

  //   links.forEach((link) => {
  //     link.addEventListener('click', (event) => {
  //       event.preventDefault();

  //       if (link.getAttribute('href') !== '#content') {
  //         util.scrollTo(link, { offset: 24 });
  //       } else {
  //         util.scrollTo(link);
  //       }
  //     });
  //   });
  // }

  //
  // Navigation
  //

  function initMenu() {
    const trigger = document.querySelector('.js-mainNavTrigger');
    const container = document.querySelector('.js-mainNavContainer');
    const body = document.querySelector('body');
    const pageHeader = document.querySelector('.js-pageHeader');

    if (!trigger || !container) return;

    subMenuTriggers = container.querySelectorAll('.js-subNavTrigger');
    subMenus = container.querySelectorAll('.js-subNavContainer');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger.classList.contains('is-active') === false) {
        trigger.classList.add('is-active');
        container.classList.add('is-active');
        body.classList.add('has-open-menu');

        // a11y: update aria attributes
        trigger.setAttribute('aria-label', trigger.dataset.closeText);
        trigger.setAttribute('aria-expanded', true);
      } else {
        trigger.classList.remove('is-active');
        container.classList.remove('is-active');
        body.classList.remove('has-open-menu');

        // a11y: update aria attributes
        trigger.setAttribute('aria-label', trigger.dataset.openText);
        trigger.setAttribute('aria-expanded', false);
      }
    });

    subMenuTriggers.forEach((subMenuTrigger, index) => {
      subMenuTrigger.addEventListener('click', (event) => {
        event.preventDefault();

        if (activeSubMenuIndex > -1 && activeSubMenuIndex != index) {
          closeSubMenu(activeSubMenuIndex);
        }

        if (subMenuTrigger.classList.contains('is-active') === false) {
          openSubMenu(index);
        } else {
          closeSubMenu(index);
        }
      });
    });

    pageHeader.addEventListener('mouseenter', (event) => {
      window.clearTimeout(closeSubMenuTimer);
    });

    pageHeader.addEventListener('mouseleave', (event) => {
      closeSubMenuTimer = window.setTimeout(() => {
        closeSubMenu(activeSubMenuIndex);
      }, 250);
    });
  }

  function openSubMenu(index) {
    closeSearchBox();

    subMenuTriggers[index].classList.add('is-active');
    subMenus[index].classList.add('is-active');

    activeSubMenuIndex = index;

    // a11y: update aria attributes
    subMenuTriggers[index].setAttribute(
      'aria-label',
      subMenuTriggers[index].dataset.closeText
    );
    subMenuTriggers[index].setAttribute('aria-expanded', true);
  }

  function closeSubMenu(index) {
    if (index === -1) return;

    subMenuTriggers[index].classList.remove('is-active');
    subMenus[index].classList.remove('is-active');

    activeSubMenuIndex = -1;

    // a11y: update aria attributes
    subMenuTriggers[index].setAttribute(
      'aria-label',
      subMenuTriggers[index].dataset.openText
    );
    subMenuTriggers[index].setAttribute('aria-expanded', false);
  }

  //
  // Search box
  //

  function initSearchBox() {
    searchTrigger = document.querySelector('.js-searchTrigger');
    searchContainer = document.querySelector('.js-searchContainer');
    if (!searchTrigger || !searchContainer) return;

    searchTrigger.addEventListener('click', (event) => {
      if (searchTrigger.classList.contains('is-active') === false) {
        openSearchBox();
      } else {
        closeSearchBox();
      }
    });
  }

  function openSearchBox() {
    if (activeSubMenuIndex > -1) {
      closeSubMenu(activeSubMenuIndex);
    }

    searchTrigger.classList.add('is-active');
    searchContainer.classList.add('is-active');

    // a11y: update aria attributes
    searchTrigger.setAttribute('aria-label', searchTrigger.dataset.closeText);
    searchTrigger.setAttribute('aria-expanded', true);

    window.setTimeout(() => {
      searchContainer.querySelector('input').focus();
    }, 250);
  }

  function closeSearchBox() {
    searchTrigger.classList.remove('is-active');
    searchContainer.classList.remove('is-active');

    // a11y: update aria attributes
    searchTrigger.setAttribute('aria-label', searchTrigger.dataset.openText);
    searchTrigger.setAttribute('aria-expanded', false);
  }

  // Expose public functions and variables
  return {
    // initScrollToAnchor: initScrollToAnchor,
    initMenu: initMenu,
    initSearchBox: initSearchBox,
  };
})();
